import AppsManagement from './components/Support/Tenant/AppsManagement';
import ParentTenant from './components/Support/Tenant/ParentTenant';
import ConfigurationManagement from './components/Support/Tenant/TenantConfigurationManagement';

export const routeNames = {
  parentTenant: 'parentTenant',
  apps: 'apps',
  configurationManagement: 'configurationManagement',
  home: 'home',
};

const companyManagementPath = '/company-management';
export const routes = [
  {
    name: routeNames.parentTenant,
    path: `${companyManagementPath}/parent-tenant`,
    component: ParentTenant,
    props: true,
  },
  {
    name: routeNames.apps,
    path: `${companyManagementPath}/apps`,
    component: AppsManagement,
    props: true,
  },
  {
    name: routeNames.configurationManagement,
    path: `${companyManagementPath}/configuration-management`,
    component: ConfigurationManagement,
    props: true,
  },
];
